import React from 'react';
import LazyLoad from 'react-lazyload';

import logoPlaceholder from '../../_assets/images/company/logo-placeholder.png';

const CompanyLogo = ({ path }) => {
  if (path)
    return (
      <LazyLoad height={100} width={100}>
        <img className="img-fluid" src={path} alt="logo" />
      </LazyLoad>
    );

  return <img className="img-fluid" src={logoPlaceholder} alt="no-logo" />;
};
export default CompanyLogo;
